//export const FETCH_PERSONS = 'FETCH_PERSONS';
//export const FETCH_VISITS = 'FETCH_VISITS';
//export const FETCH_CONFLICTED_VISITS = 'FETCH_CONFLICTED_VISITS';


export const CANCEL_VISIT = 'CANCEL_VISIT'
//export const FETCH_PATIENTS = 'FETCH_PATIENTS'
export const RESET_PATIENTS = 'RESET_PATIENTS'

//export const CHANGE_CALENDAR_DATE = 'CHANGE_CALENDAR_DATE';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_DONE = 'AUTH_DONE';

export const LOGOUT = 'LOGOUT';
//export const SET_TOKEN = 'SET_TOKEN';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';


//export const FETCH_PATIENTS_REPORT_DATA = 'FETCH_PATIENTS_REPORT_DATA';
export const SET_REPORTS_PERIOD = 'SET_REPORTS_PERIOD';
export const START_LOADING_DATA = 'START_LOADING_DATA';
export const TOGGLE_REPORTS_ACTION_BAR = 'TOGGLE_REPORTS_ACTION_BAR';

//export const REPORTS_SELECT_VISITS = 'REPORTS_SELECT_VISITS';

//export const FETCH_VISITS_REPORT_DATA = 'FETCH_VISITS_REPORT_DATA';


// NEW APPROACH
export const FIND_PATIENTS = 'FIND_PATIENTS';
export const LOAD_PATIENT = 'LOAD_PATIENT';
export const UPDATE_PATIENT = 'UPDATE_PATIENT';
export const FIND_PATIENTS_SUCCEED = 'FIND_PATIENTS_SUCCEED';
export const LOAD_PATIENT_DETAILS = 'LOAD_PATIENT_DETAILS';
export const LOAD_PATIENT_DETAILS_SUCCEED = 'LOAD_PATIENT_DETAILS_SUCCEED';
export const SHOW_PATIENT_DETAILS = 'SHOW_PATIENT_DETAILS';
export const HIDE_PATIENT_DETAILS = 'HIDE_PATIENT_DETAILS';


export const SET_CALENDAR_DATE = 'SET_CALENDAR_DATE';

export const SHOW_VISIT_DETAILS = 'SHOW_VISIT_DETAILS';
export const HIDE_VISIT_DETAILS = 'HIDE_VISIT_DETAILS';
export const CHANGE_CALENDAR_DATE = 'CHANGE_CALENDAR_DATE';

export const LOAD_THERAPISTS = 'LOAD_THERAPISTS';
export const LOAD_THERAPISTS_SUCCEED = 'LOAD_THERAPISTS_SUCCEED';

export const LOAD_VISITS = 'LOAD_VISITS';
export const LOAD_VISITS_SUCCEED = 'LOAD_VISITS_SUCCEED';
export const ADD_NEW_VISIT = 'ADD_NEW_VISIT';
export const SAVE_THERAPY = 'SAVE_THERAPY';
export const UPDATE_THERAPY_TERM = 'UPDATE_THERAPY_TERM';


export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_CONFLICTED_TERMS = 'SET_CONFLICTED_TERMS';

export const SET_VISITS_IDS_FOR_REPORTS = 'SET_VISITS_IDS_FOR_REPORTS';
export const LOAD_VISITS_REPORT_DATA = 'LOAD_VISITS_REPORT_DATA';
export const LOAD_VISITS_REPORT_DATA_SUCCEED = 'LOAD_VISITS_REPORT_DATA_SUCCEED';

export const LOAD_PATIENTS_REPORT_DATA = 'LOAD_PATIENTS_REPORT_DATA';
export const LOAD_PATIENTS_REPORT_DATA_SUCCEED = 'LOAD_PATIENTS_REPORT_DATA_SUCCEED';
export const MASS_ACTION_ON_VISITS = 'MASS_ACTION_ON_VISITS';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js